function e(e){return Array.isArray(e)}export{e as isArray};
//# sourceMappingURL=isArray-C3HaRgzz.js.map